import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=a1307208&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports